export default {
	"Coupon.CouponsAreAvailable": "可领取优惠券"
}